export const ReticulationTypeDropdown = [
  { label: "WATER", value: "WATER" },
  { label: "ELECTRICITY", value: "ELECTRICITY" },
];
